export default "__VITE_ASSET__DuEquIOb__"